// removed by extract-text-webpack-plugin
module.exports = {"agentCard":"cv_cw"};


//////////////////
// WEBPACK FOOTER
// ./src/partials/agent-card/agent-card.module.scss
// module id = 1860
// module chunks = 0